
  export default {
    props: {
      content: Object,
      description: String,
    },
  }
